import { UserContext } from "context/user";
import { useRouter } from "next/router";
import { ComponentType, useContext } from "react";
import GuestView from "./GuestView";

export function IsLoggedIn<T>(Component: ComponentType<T>) {
  const IsLoggedInComponent = (props: T) => {
    const { user } = useContext(UserContext);
    const currentSlug = useRouter()?.query?.slug?.[0];

    if (!user) return <GuestView returnUrlValue={currentSlug} />;

    return <Component {...props} />;
  };

  return IsLoggedInComponent;
}
